export default __webpack_public_path__ + "static/setup-toolbar-light-mode-d57fd0bd4f9b5004d5bae07052296741.mp4";